import { Logo, Input, Button } from '@getinapp/appetizer';
import { Row, Col } from 'react-grid-system';
import { OutlinedFlag } from '@styled-icons/material/OutlinedFlag';
import { Email } from '@styled-icons/material/Email';

import { useLoginHook } from './hooks';
import * as S from './styles';

export const Login = () => {
  const {
    isLoginOpen,
    isLoading,
    formikProps,
    handleContinueByEmail,
    handleIsOpenLoginModal,
    handleSubmit,
    t,
  } = useLoginHook();

  return (
    <S.Modal
      width="15%"
      title={<Logo size="small" />}
      isOpen={isLoginOpen}
      onRequestClose={() => handleIsOpenLoginModal(false)}
      ariaHideApp={false}
    >
      <S.Title>{t('@Login.access-or-create-your-account')}</S.Title>
      <S.Paragraph>{t('@Login.tap-your-phone-to-sign-in')}</S.Paragraph>
      <br />
      <form onSubmit={handleSubmit}>
        <Row direction="row" gutterWidth={15}>
          <Col xs={6} lg={6} xl={6} md={6}>
            <Input
              icon={<OutlinedFlag size={15} />}
              label={t('@Login.country')}
              defaultValue="+55"
              placeholder={'+55'}
              disabled
              name="country"
              mask={'+00'}
              {...formikProps('country')}
            />
          </Col>
          <Col xs={6} lg={6} xl={6} md={6}>
            <Input
              label={t('@Login.ddd')}
              placeholder="11"
              name="ddd"
              autoFocus
              mask={'00'}
              {...formikProps('ddd')}
            />
          </Col>
        </Row>
        <Row direction="row" gutterWidth={15}>
          <Col>
            <Input
              label={t('@Login.phone')}
              autoComplete="off"
              name="phone"
              helper={t('@Login.phone-helper')}
              mask={[
                {
                  mask: '00000-0000',
                },
              ]}
              {...formikProps('phone')}
            />
          </Col>
        </Row>
        <br />

        {/* @ts-ignore */}
        <Button isFullWidth loading={isLoading} type="submit">
          {t('@Login.enter')}
        </Button>

        <S.OrText>
          <span />
          {t('@Login.or')}
          <span />
        </S.OrText>

        {/* @ts-ignore */}
        <Button
          type="button"
          isFullWidth
          variant="outline"
          disabled={isLoading}
          onClick={handleContinueByEmail}
        >
          <Email size={20} />
          {t('@Login.access-with-email')}
        </Button>
      </form>
    </S.Modal>
  );
};
